import React from "react";
import { useState, useEffect } from "react";
import DirectionsCarFilledIcon from "@mui/icons-material/DirectionsCarFilled";
import CommuteIcon from "@mui/icons-material/Commute";
import RunningWithErrorsIcon from "@mui/icons-material/RunningWithErrors";


const NetworkData = ({ dataJson , selectedId  }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (dataJson && dataJson.scenario) {
        const selectedScenario = dataJson.scenario.find(scenario => scenario.replicaAvg === selectedId);
        if (selectedScenario && selectedScenario.sistema) {
            setData(selectedScenario.sistema);
        } else {
            setData(null);
        }
    }
}, [dataJson, selectedId]);
// if (!selectedId) {
//   return null; 
// }

  return (
    
    <div className="main-cards">
    
      <div className="card">
        <div className="card-inner">
          <h3>FLUSSO:</h3>
          <DirectionsCarFilledIcon className="card_icon" />
        </div>
        <h1>{data ? data.flowSys : 'Loading...'} veic/h</h1>
      </div>
      <div className="card">
        <div className="card-inner">
          <h3> CODA MEDIA:</h3>
          <CommuteIcon className="card_icon" />
        </div>
        <h1> {data ? data.qmeanSys : 'Loading...'} veic</h1>
      </div>
      <div className="card">
        <div className="card-inner">
        <h3>RITARDO MEDIO:</h3>          
        <RunningWithErrorsIcon className="card_icon" />
        </div>
        <h1>{data ? data.dtimeSys : 'Loading...'} s/km</h1>
      </div>
    </div>
  );
};

export default NetworkData;
